/** Baris gilir pegawai, lorong dan jalurnya, penugasan dan angka baris gilir di papan pemuka (Fasa 3 P3-4). */
export default {
  queue: {
    view: { label: 'Paparan', list: 'Senarai', queue: 'Baris gilir' },
    title: 'Baris gilir kerja',
    subtitle: 'Penyerahan terbuka disusun mengikut tarikh akhir terdekat.',
    asAt: 'Keutamaan setakat {{time}}',
    lanes: {
      label: 'Giliran siapa',
      authority: 'Tarikh akhir kita',
      response: 'Menunggu pihak lain',
      lapse: 'Kebenaran yang mungkin luput',
    },
    bands: {
      label: 'Tapis mengikut keutamaan',
      all: 'Semua',
      overdue: 'Lewat',
      due_soon: 'Hampir tamat tempoh',
      on_track: 'Mengikut jadual',
      applicant_turn: 'Giliran pemohon',
      uncovered: 'Tiada dalam kalendar',
      none: 'Tiada tarikh akhir',
    },
    mine: 'Kes saya',
    columns: {
      case: 'Penyerahan',
      stage: 'Peringkat',
      deadline: 'Tarikh akhir',
      band: 'Keutamaan',
      kpktDays: 'Hari KPKT',
      days: 'Hari',
      applicantDays: 'Hari pemohon',
      assignee: 'Ditugaskan kepada',
    },
    daysOf: '{{days}} daripada {{units}}',
    dueOn: 'Tamat {{date}}',
    uncoveredDue: 'Tiada tarikh sehingga kalendar meliputinya',
    unassigned: 'Belum ditugaskan',
    assignLabel: 'Tugaskan {{caseRef}}',
    assignFailed: 'Tugasan tidak disimpan: {{message}}',
    empty: 'Tiada penyerahan terbuka dalam baris gilir ini.',
    emptyMine: 'Tiada penyerahan terbuka dalam baris gilir ini yang ditugaskan kepada anda.',
    summary: {
      title: 'Tarikh akhir',
      hint: 'Penyerahan terbuka mengikut keutamaan; setiap angka membuka baris gilirnya.',
      onTime: 'Menepati masa mengikut skala',
      scale: 'Skala',
      clock: 'Tarikh akhir',
      met: 'Menepati masa',
      missed: 'Lewat',
      share: 'Peratus menepati masa',
      noScale: 'Tiada skala',
      none: 'Belum ada tarikh akhir yang dipenuhi atau terlepas.',
    },
  },
  errors: {
    invalid_assignee: 'Orang itu tidak boleh ditugaskan: pilih pegawai yang boleh bertindak atas penyerahan.',
  },
}
